import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { PRACTICE_AREAS } from "../data/firmContent";

export default function PracticeAreaDetail() {
    const { slug } = useParams();
    const area = PRACTICE_AREAS.find((p) => p.slug === slug);
    useSEO({ title: area?.title || "Practice Area", description: area?.short, path: `/practice-areas/${slug}` });
    if (!area) {
        return (
            <div className="max-w-7xl mx-auto px-4 py-24 text-center">
                <p className="font-mono-cap text-xs text-slate-500">Not found.</p>
                <Link to="/practice-areas" className="rj-link mt-4 inline-block">
                    Back to Practice Areas
                </Link>
            </div>
        );
    }
    return (
        <div data-testid={`page-practice-${area.slug}`}>
            <section className="relative bg-[#0F172A] text-[#faf9f6]">
                <div className="absolute inset-0">
                    <img src={area.image} alt={area.title} className="w-full h-full object-cover opacity-30" />
                    <div className="absolute inset-0 rj-overlay" />
                </div>
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32">
                    <Link
                        to="/practice-areas"
                        className="font-mono-cap text-xs text-[#c5a059] inline-flex items-center gap-2 mb-6 hover:text-[#faf9f6]"
                    >
                        <ArrowLeft className="w-3 h-3" /> All Practice Areas
                    </Link>
                    <div className="font-mono-cap text-xs text-[#c5a059] mb-3">{area.kicker} · Practice Area</div>
                    <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl max-w-4xl leading-[1.05]">
                        {area.title}
                    </h1>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-7">
                        <p className="font-serif-display text-2xl md:text-3xl text-slate-900 leading-relaxed">
                            {area.short}
                        </p>
                        <div className="rj-rule-gold w-12 my-8" />
                        <p className="text-slate-800 leading-relaxed text-[17px]">{area.body}</p>
                    </div>
                    <aside className="md:col-span-5 md:pl-10">
                        <div className="border border-slate-900/10 p-8 bg-[#faf9f6]">
                            <div className="font-mono-cap text-xs text-[#c5a059] mb-3">Engage Counsel</div>
                            <h3 className="font-serif-display text-2xl text-slate-900">
                                Request a confidential consultation.
                            </h3>
                            <p className="mt-3 text-sm text-slate-700">
                                Speak with a partner about your matter. All inquiries are handled in strict confidence.
                            </p>
                            <Link
                                to="/contact"
                                className="mt-6 inline-flex items-center gap-2 bg-[#0F172A] text-[#faf9f6] px-6 py-3 rounded-sm hover:bg-[#c5a059] hover:text-[#0F172A] transition-colors"
                                data-testid={`practice-cta-${area.slug}`}
                            >
                                Book Consultation <ArrowUpRight className="w-4 h-4" />
                            </Link>
                        </div>
                    </aside>
                </div>
            </section>
        </div>
    );
}
